<template>
  <main class="form-page overflow-x-hidden bg-[#0d2651]">
    <div
      v-if="formErrorOpen"
      class="fixed inset-0 z-[120] bg-black/50 flex items-center justify-center px-4"
    >
      <div
        class="w-full max-w-[560px] rounded-2xl bg-white p-5 sm:p-6 relative"
      >
        <button
          type="button"
          class="absolute top-3 right-3 text-[#0D2651] hover:opacity-80 transition-opacity"
          @click="formErrorOpen = false"
          aria-label="Fermer la popup des erreurs"
        >
          <i class="fa-solid fa-xmark text-xl"></i>
        </button>
        <h3
          class="font-barlow-condensed font-bold uppercase text-[#0D2651] text-[28px] sm:text-[32px] leading-tight text-center mb-4"
        >
          Le formulaire contient des erreurs
        </h3>
        <ul
          class="list-disc pl-6 pr-2 space-y-2 text-[#0D2651] text-base sm:text-lg"
        >
          <li
            v-for="(message, index) in formErrorMessages"
            :key="`${message}-${index}`"
          >
            {{ message }}
          </li>
        </ul>
        <div class="mt-6 text-center">
          <button
            type="button"
            class="inline-flex items-center justify-center rounded-full bg-[#0D2651] px-6 py-2.5 text-white font-barlow-condensed font-bold uppercase text-lg leading-none hover:opacity-90 transition-opacity"
            @click="formErrorOpen = false"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="help"
      class="w-full h-full bg-black/50 z-50 fixed inset-0 flex justify-center items-center"
    >
      <div class="bg-white text-[#0067A4] p-4 rounded-lg relative">
        <i
          class="absolute right-2 top-2 fa-solid fa-xmark cursor-pointer"
          @click="help = false"
        ></i>
        <p class="text-lg text-center pt-3">
          Le numéro à 13 chiffres démarre<br />
          par 30190 pour les boîtes de thon et<br />
          37602 pour les paquets de saumon.
        </p>
      </div>
    </div>

    <div
      class="fixed inset-0 h-full w-full z-[100] pointer-events-none"
      v-if="vague"
    >
      <img
        v-if="vague"
        :key="'vague-desk-' + vagueReplayKey"
        :src="`/vague.gif?r=${vagueReplayKey}`"
        class="w-full h-full object-cover hidden sm:block"
        alt=""
      />
      <img
        :key="'vague-mob-' + vagueReplayKey"
        :src="`/vague-mobile.gif?r=${vagueReplayKey}`"
        class="w-full h-full object-cover sm:hidden"
        alt=""
      />
    </div>
    <audio
      ref="audioPlayer"
      src="/audiomass-output2.mp3"
      preload="auto"
    ></audio>

    <!-- Section 1 : formulaire (vague en fond, comme home1 sur la homepage) -->
    <section
      id="form-main-section"
      class="form-section-1 bg-[#0d2651] h-auto min-h-[500px] lg:h-[800px] xl:h-[900px] flex items-stretch justify-center relative z-0"
    >
      <div
        class="mx-auto relative h-full w-full min-w-0 max-w-[1440px] flex flex-col min-h-0 bg-cover bg-center bg-no-repeat"
        :style="{ backgroundImage: `url(${fondPerdu})` }"
      >
        <div
          class="form-section1-main flex-1 min-h-0 min-w-0 flex items-center justify-center w-full pt-24 xs:pt-12"
        >
          <div
            class="max-w-6xl mx-auto w-full min-w-0 flex flex-wrap lg:flex-nowrap justify-between items-center py-[10%] sm:py-0 px-4 sm:px-6 lg:gap-16"
          >
            <!-- Colonne gauche – texte -->
            <div
              class="w-full min-w-0 max-w-full lg:max-w-[506px] text-center lg:text-left mb-10 lg:mb-0 pt-0 lg:-mt-16 xl:-mt-24"
            >
              <h1
                class="font-barlow-condensed font-bold uppercase text-white text-[28px] leading-[1.2] mb-6 lg:mb-8 lg:text-[40px] lg:leading-[48px] break-words"
              >
                POUR SAVOIR SI VOUS AVEZ GAGNÉ UN VOYAGE, NOUS DEVONS VÉRIFIER
                LE CODE UNIQUE PRÉSENT SUR VOTRE PRODUIT PETIT NAVIRE
              </h1>
              <p
                class="text-white font-barlow-condensed font-bold text-xl sm:text-2xl lg:text-[24px] lg:leading-[28px] lg:max-w-[420px] break-words"
              >
                Après avoir rempli ce formulaire, vous recevrez la liste des
                étapes à suivre.
              </p>
              <button
                type="button"
                class="mt-6 inline-flex justify-center lg:justify-start hover:opacity-95 transition-opacity"
                @click="scrollToCodeSection"
              >
                <img
                  src="@/assets/images/forms/ou-trouver-mon-code.svg"
                  alt="Où trouver mon code ?"
                  class="h-auto w-full max-w-[320px] sm:max-w-[360px]"
                />
              </button>
            </div>
            <!-- Colonne droite – formulaire -->
            <div
              class="form-card w-full min-w-0 max-w-[588px] mx-auto lg:mx-0 lg:mb-6 xl:mb-8"
            >
              <div class="bg-white rounded-3xl px-4 py-6 min-w-0">
                <div class="min-w-0 w-full">
                  <Form
                    class="w-full max-w-full mx-auto"
                    id="createForm"
                    form_id="6904b53e310c505cd7f8a34e"
                    server="https://api-gabarit.promo.dev"
                    v-on:results="getResult"
                    v-on:form_submit_loading="onLoading"
                    :hideError="hiderror"
                    @on_error="showErrorForm"
                    :relay="relay"
                  />
                </div>
                <div class="mention2 mt-4 text-[#0D2651] text-sm text-center">
                  *Champs obligatoires
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bande bleue réservée au chevauchement de la vague (section 2) — plus haute que le -mt pour ne pas toucher au formulaire -->
        <div
          class="form-section1-wave-buffer h-28 sm:h-32 lg:h-40 xl:h-48 2xl:h-56 shrink-0 w-full min-h-[4rem]"
          aria-hidden="true"
        />
      </div>
    </section>

    <!-- Section 2 : Où trouver mon code ? (en dessous, comme home2 sur la homepage) -->
    <section
      id="form-code-section"
      class="form-code-section-wave relative z-[30] pt-0 pb-0 -mt-10 sm:-mt-12 md:-mt-14 lg:-mt-24 xl:-mt-32 2xl:-mt-36 pointer-events-none bg-[#0d2651] bg-no-repeat bg-top bg-cover md:bg-[length:100%_auto] md:bg-top"
      :style="{ backgroundImage: `url(${fondSection2})` }"
    >
      <div
        class="relative flex flex-col items-center justify-center gap-7 w-full min-w-0 max-w-[1440px] mx-auto text-center px-4 box-border min-h-[900px] pt-16 pb-[5.5rem] sm:pt-20 sm:pb-20 lg:gap-9 lg:min-h-[1100px] lg:pt-24 xl:pt-28 lg:pb-48 pointer-events-auto overflow-hidden"
      >
        <div class="shrink-0 w-full">
          <div
            class="inline-flex min-h-[88px] h-auto items-center justify-center gap-2.5 rounded-2xl bg-[#feefc7] px-5 py-3 mb-4 lg:h-[88px] lg:min-h-0 lg:py-2 lg:px-5"
          >
            <h2
              class="m-0 font-barlow-condensed font-bold uppercase text-center text-[#0D2651] text-[clamp(1.5rem,8vw,4rem)] leading-[1.1875] lg:text-[64px] lg:leading-[76px]"
            >
              OÙ TROUVER MON CODE ?
            </h2>
          </div>
          <p
            class="m-0 font-barlow-condensed font-bold uppercase text-center text-[#0D2651] text-[clamp(1.125rem,4vw,2.5rem)] leading-snug px-2 lg:text-[40px] lg:leading-[48px]"
          >
            POUR SAVOIR SI VOUS AVEZ GAGNÉ
          </p>
        </div>

        <div
          class="flex-initial flex items-center justify-center min-h-0 p-0 w-full"
        >
          <div
            class="w-[85%] max-w-[420px] md:w-full md:max-w-[1010px] grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6 mx-auto justify-items-center"
          >
            <img
              src="@/assets/images/forms/form-gauche.png"
              alt="Boîte de thon Petit Navire - où trouver le code"
              class="w-full md:max-w-[493px] rounded-2xl"
            />
            <img
              src="@/assets/images/forms/form-droite.png"
              alt="Paquet de saumon Petit Navire - où trouver le code"
              class="w-full md:max-w-[493px] rounded-2xl"
            />
          </div>
        </div>

        <div class="shrink-0 flex flex-col gap-5 w-full mt-0 pt-0">
          <div class="text-center px-2">
            <button
              type="button"
              @click="scrollToFormSection"
              class="inline-flex w-full max-w-[780px] box-border flex-col items-center justify-center gap-[10px] rounded-[50px] bg-white text-center font-barlow-condensed font-bold not-italic uppercase no-underline text-[#0D2651] border-0 max-md:px-5 max-md:py-3 max-md:text-[clamp(0.9375rem,4.2vw,1.125rem)] max-md:leading-snug max-md:h-auto md:h-[84px] md:pt-[10px] md:pb-[12px] md:px-[40px] md:!text-[48px] md:!leading-[60px] transition-colors duration-200 hover:bg-[#0D2651] hover:text-white"
            >
              JE DÉCOUVRE SI MON CODE EST GAGNANT
            </button>
          </div>
          <div
            class="m-0 text-center text-[#0D2651] font-barlow-condensed font-bold not-italic text-lg leading-[25px] px-3 max-w-2xl mx-auto"
          >
            <span class="inline text-inherit"
              >*Découvrez la liste des produits éligibles en
            </span>
            <a
              href="/documents/Fiche%20produit%20site_voyage.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="inline text-[#0D2651] underline decoration-solid underline-offset-2 transition-opacity hover:opacity-90"
            >
              cliquant ici
            </a>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { setGameResult } from "@/gameResult";
import router from "@/router";
import { ref, onMounted, onBeforeUnmount } from "vue";
import fondPerdu from "@/assets/images/fond-perdu.svg";
import fondSection2 from "@/assets/images/forms/fond-section2.png";

const hiderror = ref(true);
const loading = ref(false);
const error = ref(false);
const relay = ref();
const vague = ref(false);
/** Incrémenté à chaque vague : force le rechargement du GIF (sinon le navigateur ne relance pas l’anim). */
const vagueReplayKey = ref(0);

let vagueNavTimer = null;
let vagueNavGen = 0;
const audioPlayer = ref(null);
const help = ref(false);
const formErrorOpen = ref(false);
const formErrorMessages = ref([]);
let nativeAlert = null;

const openFormErrorPopup = (messages) => {
  const fallback = [
    "Une erreur est survenue. Veuillez vérifier les champs du formulaire.",
  ];
  formErrorMessages.value =
    Array.isArray(messages) && messages.length ? messages : fallback;
  formErrorOpen.value = true;
};

const onLoading = () => {
  loading.value = true;
};

const showErrorForm = (event) => {
  const rawError = event?.error;
  const fallback = [
    "Une erreur est survenue. Veuillez vérifier les champs du formulaire.",
  ];
  const messages = Array.isArray(rawError?.message)
    ? rawError.message
    : typeof rawError?.message === "string"
    ? rawError.message.split("\n").filter(Boolean)
    : Array.isArray(rawError?.errors)
    ? rawError.errors
        .map((item) =>
          typeof item === "string"
            ? item
            : item?.message || item?.error || null,
        )
        .filter(Boolean)
    : fallback;
  openFormErrorPopup(messages.length ? messages : fallback);
  loading.value = false;
  error.value = true;
};

const scrollToCodeSection = () => {
  const section = document.getElementById("form-code-section");
  if (!section) return;

  const offset = 100;
  const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({
    top: sectionTop - offset,
    behavior: "smooth",
  });
};

const scrollToFormSection = () => {
  const section = document.getElementById("form-main-section");
  if (!section) return;

  const offset = 100;
  const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({
    top: sectionTop - offset,
    behavior: "smooth",
  });
};

/** Lance GIF + son puis appelle onDone après 1,7 s (annule les timers précédents). */
const runVagueAnimation = (onDone) => {
  if (vagueNavTimer != null) {
    clearTimeout(vagueNavTimer);
    vagueNavTimer = null;
  }
  vagueNavGen += 1;
  const gen = vagueNavGen;

  vagueReplayKey.value += 1;
  vague.value = true;
  void audioPlayer.value?.play?.().catch(() => {});

  vagueNavTimer = setTimeout(() => {
    vagueNavTimer = null;
    if (gen !== vagueNavGen) return;
    vague.value = false;
    onDone?.();
  }, 1700);
};

const getResult = (result) => {
  if (result && result.status) {
    setGameResult(result, "form");
    runVagueAnimation(() => {
      const status = (result.status || "").toString().toUpperCase();
      const lot = (result.lot || "").toString().toLowerCase();

      if (status === "GAGNE" && lot === "voyage") {
        router.push({ path: "/gagner-voyage" });
        return;
      }

      if (status === "PERD") {
        router.push({ name: "code-perdant" });
        return;
      }

      router.push({ path: "/end" });
    });
  } else {
    alert("Une erreur est survenue, veuillez réessayer plus tard.");
  }
};

onMounted(() => {
  nativeAlert = window.alert;
  window.alert = (message) => {
    const msg = String(message || "");
    if (
      msg.includes(
        "Veuillez vérifier les erreurs restantes dans le formulaire",
      ) ||
      msg.includes("Corrigez les erreurs")
    ) {
      openFormErrorPopup([msg]);
      loading.value = false;
      error.value = true;
      return;
    }
    nativeAlert?.(message);
  };

  vague.value = false;
  setTimeout(() => {
    const element = document.querySelector("#infosbull");
    if (element) {
      element.addEventListener("click", () => {
        help.value = true;
      });
    }
  }, 1000);
});

onBeforeUnmount(() => {
  if (vagueNavTimer != null) {
    clearTimeout(vagueNavTimer);
    vagueNavTimer = null;
  }
  if (nativeAlert) {
    window.alert = nativeAlert;
  }
});
</script>

<style scoped>
/* Évite le débordement horizontal du builder en mobile (flex : min-width auto par défaut) */
.form-section-1 :deep(#createForm) {
  min-width: 0;
  width: 100%;
  max-width: 100%;
}
.form-section-1 :deep(#createForm .form-step) {
  min-width: 0;
  width: 100%;
}
.form-section-1 :deep(#createForm .input_wrapper),
.form-section-1 :deep(#createForm [class*="input_wrapper_"]) {
  min-width: 0 !important;
  max-width: 100% !important;
}
.form-section-1
  :deep(
    #createForm
      input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not(
        [type="hidden"]
      ):not([type="submit"]):not([type="button"])
  ),
.form-section-1 :deep(#createForm select),
.form-section-1 :deep(#createForm textarea) {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

/* overflow-x seulement sur main : clip sur .form-section-1 faisait passer la s2 « sous » la s1 au chevauchement */
.form-page,
#form-code-section {
  width: 100%;
  max-width: 100vw;
  overflow-x: clip;
}

/* CTA formulaire (section 1) : bouton remplacé par CTA-form1.svg, comme form2 */
.form-section-1 :deep(.builder-buttons) {
  display: flex;
  justify-content: center !important;
  width: 100%;
}
.form-section-1 :deep(#next_button) {
  width: 454px;
  max-width: 100%;
  height: 58px;
  padding: 0 !important;
  margin: 0;
  border: none !important;
  border-radius: 29px;
  background: url("@/assets/images/forms/CTA-form1.svg") center / contain
    no-repeat !important;
  background-color: #0d2651 !important;
  color: transparent !important;
  font-size: 0;
  text-indent: -9999px;
  cursor: pointer;
  overflow: hidden;
  transition: none !important;
}
.form-section-1 :deep(#next_button:hover) {
  background: url("@/assets/images/forms/CTA-form1.svg") center / contain
    no-repeat !important;
  background-color: #0d2651 !important;
  color: transparent !important;
  border: none !important;
}

.form-section-1 :deep(.builder-buttons) {
  margin-bottom: 1.5rem;
}

/* Garde l'astérisque du règlement aligné avec le texte */
.form-section-1 :deep(#opt_in_rules_element label) {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 0.25rem;
}
.form-section-1 :deep(#opt_in_rules_element label > div) {
  display: inline;
}
.form-section-1 :deep(#opt_in_rules_element .required-star) {
  white-space: nowrap;
  line-height: 1;
}

/* Label EAN : tout doit tenir sur une seule ligne (texte + icône + étoile)
   pour éviter que l’étoile se retrouve isolée sur sa propre ligne. */
.form-section-1 :deep(.input_wrapper_ean label) {
  display: block;
  white-space: nowrap;
}
.form-section-1 :deep(.input_wrapper_ean label img#infosbull) {
  display: inline;
  vertical-align: middle;
}
.form-section-1 :deep(.input_wrapper_ean label .required-star) {
  display: inline;
  white-space: nowrap;
}
</style>
